import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from '../../provider/authProvider';
import api from '../../api/axios';
import Topbar from '../layout/Topbar';
import { useBookStore } from '../../provider/BookStore';
import { RotatingLines } from 'react-loader-spinner';


const Book = () => {
    const [name, setName] = useState('');
    const [books, setBooks] = useState([]);
    const { token } = useAuth();
    const navigate = useNavigate();

    const bookState = useBookStore();
    const [isLoading, setLoading] = useState(false);


    useEffect(() => {
        welcomeUser();
        populateBooks();
    }, []);

    const welcomeUser = () => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setName(decoded.sub);
            } catch (e) {
                console.log('Token decode error:', e);
                setName('');
            }
        } else {
            setName('');
        }
    }

    const populateBooks = async () => {
        setLoading(true)
        try {
            const response = await api.get('/books');
            const allBooks = response.data.books || [];
            console.log(allBooks);
            setBooks(allBooks)
        } catch (error) {
            console.log(error.response)
        }
        setLoading(false)
    }

    const GoToTransactions = (book) => {
        console.log(book)
        bookState.setBook(book);
        navigate('/transactions', {
            state: {
                book: {
                    id: book.id,
                    title: book.title,
                }
            }
        })
    }

    const goAddBook = () => {
        navigate('/book/add');
    }

    return (
        <div>
            <Topbar
                page={'home'}
                title={'Bukukas'}
                isLoading={isLoading}
            />
            <div className='container p-5'>

                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">

                        <p className='is-size-6 mb-4 ml-4'>Selamat datang {name}</p>

                        <div className='card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Daftar Buku Kas</p>
                                <button className="card-header-icon" onClick={goAddBook}>
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </header>
                            <div className='card-content'>
                                {books.map((book, index) => (
                                    <div key={index} className='is-clickable mb-2' onClick={() => GoToTransactions(book)}>
                                        <div className='is-clearfix'>
                                            <div className='is-pulled-left'>
                                                <p className='is-size-6'> {book.title}</p>
                                            </div>

                                            <div className='is-pulled-right'>
                                                {/* <span className="icon ">
                                                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                                </span> */}
                                            </div>

                                        </div>
                                        <hr className='mt-3 mb-3' />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className='mb-6 card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Hutang Piutang</p>
                                <button className="card-header-icon" >
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </header>
                            <div className='card-content'>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Book
